import App from "@/store/modules/App";
import Companies from "@/store/modules/Companies";
import Customers from "@/store/modules/Customers";
import Tasks from "@/store/modules/Tasks";

export default {
  App,
  Companies,
  Customers,
  Tasks,
};
